import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('batchPrintingVerification', 'batchPrintingVerifications');

const customActions = {
  async LOAD_batchPrintingVerifications({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('batchPrintingVerifications')
      .query(
        {
          $filter: 'status ne null',
          $expand: 'StockItem',
        },
      );
    commit('SET_batchPrintingVerifications', data);
    return data;
  },
};

export default { ...actions, ...customActions };
